module.exports = __webpack_public_path__ + "img/Photo_5__Fourth_Canal_990_25_1.2730fee4.jpg";